import api from '@/services/api'

const notificaciones = {
  listar:      ()         => api.get('/notificaciones').then(r => r.data),
  crear:       (data)     => api.post('/notificaciones', data).then(r => r.data),
  actualizar:  (id, data) => api.put(`/notificaciones/${id}`, data).then(r => r.data),
  eliminar:    (id)       => api.delete(`/notificaciones/${id}`).then(r => r.data),
}

export default notificaciones
